module.exports = __webpack_public_path__ + "img/map.c59ab805.svg";